import { fetchResults } from '@/lib/utils/fetchResults';
import { SearchResults, SearchResultsByCategory } from '@/lib/models/Search';
import { ALL_CATEGORIES } from '@/lib/constants/Search';

export async function fetchSearchResults(query: string, locale: string): Promise<SearchResultsByCategory> {
  if (!query?.trim()) {
    const emptyResults: SearchResults = { hits: [], count: 0, totalPages: 0 };
    return { all: emptyResults, knowledgebase: emptyResults, documentation: emptyResults, templates: emptyResults };
  }

  const allResults = await fetchResults(query, locale, ALL_CATEGORIES, 1);
  const [knowledgebase, documentation, templates] = await Promise.all([
    fetchResults(query, locale, 'knowledgebase', 1),
    fetchResults(query, locale, 'documentation', 1),
    fetchResults(query, locale, 'templates', 1),
  ]);

  return { all: allResults, knowledgebase, documentation, templates };
}
